export const GET_QUIZZES = 'quiz/GET_QUIZZES'
export const GET_QUIZ = 'quiz/GET_QUIZ'
export const ADD_QUIZ = 'quiz/ADD_QUIZ'
export const EDIT_QUIZ = 'quiz/EDIT_QUIZ'
export const DELETE_QUIZ = 'quiz/DELETE_QUIZ'
export const RESET_QUIZ = 'quiz/RESET_QUIZ'
export const RESET_ADD_QUIZ_SUCCESS = 'quiz/RESET_ADD_QUIZ_SUCCESS'
export const RESET_EDIT_QUIZ_SUCCESS = 'quiz/RESET_EDIT_QUIZ_SUCCESS'
